"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigningStatusDisplay = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const get_signing_status_1 = require("../../../../../api/calls/document/get_signing_status");
const document_1 = require("../../../../../reducers/slices/document/document");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const SigningStatusDisplay = ({ documentId }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const signingStatus = (0, react_redux_1.useSelector)((state) => state.documentState.signingStatus);
    const [lastRefreshed, setLastRefreshed] = (0, react_1.useState)(new Date());
    const [isLoading, setIsLoadingLocal] = (0, react_1.useState)(true);
    const [hasError, setHasError] = (0, react_1.useState)(false);
    const loadSigningStatus = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!documentId)
            return;
        setIsLoadingLocal(true);
        setHasError(false);
        dispatch((0, document_1.setIsLoading)(true));
        try {
            const response = yield (0, get_signing_status_1.get_signing_status)({ document_id: documentId });
            if (response.success) {
                dispatch((0, document_1.setSigningStatus)(response.content));
                setLastRefreshed(new Date());
                setHasError(false);
            }
            else {
                console.error("Failed to load signing status:", response.message);
                setHasError(true);
            }
        }
        catch (error) {
            console.error("Failed to load signing status:", error instanceof Error ? error.message : String(error));
            setHasError(true);
        }
        finally {
            dispatch((0, document_1.setIsLoading)(false));
            setIsLoadingLocal(false);
        }
    }), [documentId, dispatch]);
    (0, react_1.useEffect)(() => {
        loadSigningStatus();
    }, [loadSigningStatus]);
    // Don't render anything if there's an authentication error
    if (hasError && !signingStatus) {
        return null;
    }
    if (isLoading && !signingStatus) {
        return (react_1.default.createElement("div", { className: "bg-white p-6 rounded-lg shadow" },
            react_1.default.createElement("div", { className: "text-center text-gray-500" }, "Loading signing status...")));
    }
    if (!signingStatus) {
        return null;
    }
    const getStatusIcon = (status) => {
        switch (status) {
            case "COMPLETED":
                return react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheckCircle, className: "text-green-500" });
            case "IN_PROGRESS":
                return react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSpinner, className: "text-blue-500" });
            case "PENDING":
            default:
                return react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCircle, className: "text-gray-400" });
        }
    };
    const getStatusText = (status) => {
        switch (status) {
            case "COMPLETED":
                return "Completed";
            case "IN_PROGRESS":
                return "In Progress";
            case "PENDING":
            default:
                return "Pending";
        }
    };
    const completionPercentage = signingStatus.total_signers > 0 ? Math.round((signingStatus.completed_signers / signingStatus.total_signers) * 100) : 0;
    return (react_1.default.createElement("div", { className: "bg-white p-6 rounded-lg shadow" },
        react_1.default.createElement("div", { className: "flex justify-between items-center mb-6" },
            react_1.default.createElement("h3", { className: "text-xl font-bold" }, "Signing Status"),
            react_1.default.createElement("button", { onClick: loadSigningStatus, className: "flex items-center gap-2 px-3 py-1 text-sm text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded transition-colors", title: "Refresh signing status" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faRefresh }),
                "Refresh")),
        react_1.default.createElement("div", { className: "mb-6" },
            react_1.default.createElement("div", { className: "flex justify-between mb-2" },
                react_1.default.createElement("span", { className: "text-sm font-medium text-gray-700" }, "Overall Progress"),
                react_1.default.createElement("span", { className: "text-sm font-medium text-gray-700" },
                    signingStatus.completed_signers,
                    " of ",
                    signingStatus.total_signers,
                    " completed (",
                    completionPercentage,
                    "%)")),
            react_1.default.createElement("div", { className: "w-full bg-gray-200 rounded-full h-2" },
                react_1.default.createElement("div", { className: "bg-green-500 h-2 rounded-full transition-all duration-300", style: { width: `${completionPercentage}%` } }))),
        react_1.default.createElement("div", { className: "grid grid-cols-3 gap-4 mb-6" },
            react_1.default.createElement("div", { className: "bg-green-50 p-4 rounded-lg text-center" },
                react_1.default.createElement("div", { className: "text-2xl font-bold text-green-600" }, signingStatus.completed_signers),
                react_1.default.createElement("div", { className: "text-sm text-gray-600" }, "Completed")),
            react_1.default.createElement("div", { className: "bg-blue-50 p-4 rounded-lg text-center" },
                react_1.default.createElement("div", { className: "text-2xl font-bold text-blue-600" }, signingStatus.in_progress_signers),
                react_1.default.createElement("div", { className: "text-sm text-gray-600" }, "In Progress")),
            react_1.default.createElement("div", { className: "bg-gray-50 p-4 rounded-lg text-center" },
                react_1.default.createElement("div", { className: "text-2xl font-bold text-gray-600" }, signingStatus.pending_signers),
                react_1.default.createElement("div", { className: "text-sm text-gray-600" }, "Pending"))),
        react_1.default.createElement("div", null,
            react_1.default.createElement("h4", { className: "text-sm font-medium text-gray-700 mb-3" }, "Signers"),
            react_1.default.createElement("div", { className: "space-y-2" }, signingStatus.signers.map((signer, index) => (react_1.default.createElement("div", { key: signer._id, className: "flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" },
                react_1.default.createElement("div", { className: "flex items-center gap-3" },
                    react_1.default.createElement("div", { className: "text-lg" }, getStatusIcon(signer.status)),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "font-medium" },
                            signer.first_name,
                            " ",
                            signer.last_name),
                        react_1.default.createElement("div", { className: "text-sm text-gray-600" }, signer.email))),
                react_1.default.createElement("div", { className: "text-right" },
                    react_1.default.createElement("div", { className: "text-sm font-medium" }, getStatusText(signer.status)),
                    signer.signed_at && react_1.default.createElement("div", { className: "text-xs text-gray-500" }, new Date(signer.signed_at).toLocaleDateString()))))))),
        react_1.default.createElement("div", { className: "mt-4 text-xs text-gray-500 text-center" },
            "Last refreshed: ",
            lastRefreshed.toLocaleTimeString())));
};
exports.SigningStatusDisplay = SigningStatusDisplay;
